var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Room.WebNormalPurlGet",
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "RoomWebNormalPurlGet"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 1
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "purl",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "keepTime",
                    "id": 2
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/webchat/purl.pb.js